export const listViewDefaulttemplate = {
  mapView: {},
  namedFilters: [],
  treeView: {
    columns: [],
  },
  nestedChartConfig: {
    measurableFields: [],
  },
  columns: [
    {
      name: "REFERENCE_ID",
      type: "text",
      displayName: "Applicant Ref #",
      enableLink: true,
    },
  ],
  pageTitle: "Export Letter of Credit Inquiry",
  pageSize: 50,
  screen: "applicant",
  viewDynamic: true,
  widgets: [
    {
      codeValue: "List",
      name: "List",
    },
  ],
  formActions: {
    edit: null,
    create: null,
    show: "1aed37da-9abb-4cc8-a552-730b9c1e129a",
    hideActionShow: true,
  },
  listView: {
    lines: [],
  },
  cardView: {},
  calendarView: {},
  timelineView: {},
  kanbanView: {},
  defaultWidget: "Tabular",
  pagenationBottom: true,
  noDataMessage: {},
  customSorting: [],
  isVersionable: true,
  actionList: [],
  filters: [],
  hookFields: [],
  inlinePagination: {},
  editDynamic: true,
  pagenationBottomRight: true,
  actionBuilders: [
    {
      buttonStyle: "flat",
      publishClickEvent: true,
      targetProductCode: "BS_PROJECTS",
      nestedPageType: "",
      customFunction: "",
      actionCode: "NESTED_LINK",
      publishClickEventName: "DynamicEditEvent",
      targetProductName: "BS_PROJECTS",
      actionPurpose: "Edit X",
      blockLabel: "",
      icon: "fa fa-pencil-square-o",
      actionname: "Dynamic Edit",
      selected: true,
    },
    {
      buttonStyle: "flat",
      publishClickEvent: true,
      targetProductCode: "ALL_DATA_TYPES",
      productDetails: {
        typeCode: "ALL_DATA_TYPES",
        subTypeCode: "ALL_DATA_TYPES",
      },
      nestedPageType: "",
      customFunction: "",
      actionCode: "Summary",
      publishClickEventName: "DynamicViewEvent",
      targetProductName: "All Data Types",
      actionPurpose: "Edit X",
      blockLabel: "",
      icon: "fa fa-eye",
      actionname: "Dynamic View",
      selected: true,
    },
  ],
};
